module.exports = __webpack_public_path__ + "img/message-music.82f71073.svg";